<template>
  <div class="lvAppointmentUser">
    <div class="lvAppTitle">
      <div class="lvAppTitleLeft">最近预约</div>
      <div class="lvAppTitleRight">
        <span>{{ orderNum }}人已预约</span>
        <img :src= "require('../../../assets/app/userIcon.png')" alt="">
      </div>
    </div>

    <div class="lvAppImg">
      <div v-for="(item, index) in arrUserImg">
        <div class="imgItem"
             :key="index"
             :ref="`r${index}`">
          <img v-if="item.userImg!=''" style="width: 100%; height: 100%" :src= "item.userImg" alt="">
          <img v-else style="width: 100%; height: 100%" :src= "require('../../../assets/live/defaultUser.png')" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {apiLive} from "../../../network/app/apiPlatformLive";
import {actUtil} from "../../../js/activity/util";

export default {
  name: "lvAppointmentUser",
  props:{
    liveId: {
      type: Number,
      required: true
    },
    orderNum: {
      type: Number,
      required: true
    }
  },
  watch:{
    liveId: {
      handler(newVal,oldVal) {
        if(newVal!=0){
          // console.log('liveId====================='+this.liveId)
          this.refreshOrder(newVal)
        }else{
          // console.log('liveId$$$$$$$$$$$$$$$$$$$$$='+this.liveId)
        }

      },
    },
    orderNum:{
      handler(newVal,oldVal) {
        if(newVal!=0){
          // console.log('orderNum====================='+this.orderNum)
        }else{
          // console.log('orderNum='+this.orderNum)
        }

      },
    }
  },
  data(){
    return {
      count: 20,
      arrUserImg: []
    }
  },
  created() {
    // console.log('获取预约信息')
    if(this.liveId!=0){
      this.refreshOrder(this.liveId)
    }
  },
  methods:{
    getItem(order){
      let obj = {}
      obj.userImg = order.userImg
      return obj
    },
    refreshOrder(id){
      let obj = {
        'id': id, //直播编号   (bigInteger)
        'start': 0,   //偏移0       (Integer) (可选)
        'limit':20,   //条数50     (Integer) (可选)
      }
      apiLive.getPlatformLiveOrders(obj).then(res=>{
        // console.log('获取预约 成功')
        // console.log(res.orders)
        this.arrUserImg.length=0
        if(typeof res.orders != "undefined") {
          for (let i=0; i<res.orders.length; i++){
            let retObj = this.getItem(res.orders[i])
            if(retObj!=null){
              this.arrUserImg.push(retObj)
            }
          }
        }
      }).catch(err=>{

      })
    }
  }
}
</script>

<style scoped>
.lvAppointmentUser{
  margin: auto;
  width: 920px;
  /*height: 300px;*/
  /*background-color: #9d8181;*/
}
.lvAppTitle{
  height: 42px;
  line-height: 42px;
  font-size: 40px;
  color: #1f242d;
  margin-bottom: 20px;
}
.lvAppTitleLeft{
  float: left;
  height: 100%;
  width: 300px;
  /*background-color: #ead287;*/
}
.lvAppTitleRight{
  float: right;
  height: 100%;
  width: 600px;
  text-align: right;
  /*background-color: #ff5777;*/
  /*background-image: url("../../../assets/app/userIcon.png");*/
  /*background-size: 40px 40px;*/
  /*background-repeat: no-repeat;*/
}
.lvAppTitleRight img{
  float: right;
  width: 42px;
  height: 42px;
}
.lvAppTitleRight span{
  float: right;
  line-height: 42px;
  padding-left: 20px;
}

.lvAppImg{
  height: 120px;
  width: 920px;
  /*background-color: #ff5777;*/
  display: flex;
  flex-direction: row;
  overflow-y: hidden;

}

.imgItem{
  width: 120px;
  height: 120px;
  margin-right: 40px;
  /*background-color: #4b4b4b;*/
  border-radius: 10px;
}
</style>